import React from 'react'
import {
  Modal,
  Paper,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@material-ui/core'
import styles from './QuickAccessModal.module.css'

const QuickAccessModal = ({
  open,
  quickAccessUrl,
  onClose,
  clientName,
  title = 'Acceso rápido generado',
  successMessage = clientName
    ? `¡Listo para compartir con ${clientName}!`
    : '¡Listo para compartir!',
  expirationMessage = 'Esta URL expirará en 1 hora'
}) => {
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(quickAccessUrl)
  }

  return (
    <Modal
      open={open}
      disablePortal={false}
      style={{ width: '50%', margin: '200px auto' }}
    >
      <Paper>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <div className={styles.modalContainer}>
            <div className={styles.modalContent}>
              <i className={`material-icons ${styles.successIcon}`}>
                check_circle
              </i>
              <Typography variant='h6' className={styles.successMessage}>
                {successMessage}
              </Typography>
              <Typography
                variant='body2'
                style={{ color: '#6c757d', marginBottom: '20px' }}
              >
                {expirationMessage}
              </Typography>
              <Button
                variant='contained'
                color='primary'
                size='medium'
                startIcon={<i className='material-icons'>content_copy</i>}
                onClick={handleCopyUrl}
                className={styles.copyButton}
              >
                Copiar URL
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='secondary'>
            Cerrar
          </Button>
        </DialogActions>
      </Paper>
    </Modal>
  )
}

export default QuickAccessModal
